import { CSSObject } from "@emotion/react";

export const optionsCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
};
